import React, { FunctionComponent } from 'react';

import Footer from '../layout/Footer';
import Main from '../layout/Main';
import ClientNavbar from './layout/ClientNavbar';
import {Outlet} from 'react-router-dom';

interface Props {}

const ClientContent: FunctionComponent<Props> = () => {

    return (
        <React.Fragment>
            <ClientNavbar/>

            <Main>
                <Outlet />
            </Main>

            <Footer/>
        </React.Fragment>
    );
};

export default ClientContent;
